export default __webpack_public_path__ + "static/media/power.2215cf55.svg";